import { render, staticRenderFns } from "./dialog4.vue?vue&type=template&id=59212ea8&scoped=true&"
import script from "./dialog4.vue?vue&type=script&lang=js&"
export * from "./dialog4.vue?vue&type=script&lang=js&"
import style0 from "./dialog4.vue?vue&type=style&index=0&id=59212ea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59212ea8",
  null
  
)

export default component.exports